import { BankAccount } from 'types/payment';

export const plaidEntry: BankAccount = {
	id: '-1',
	label: 'New bank account',
	primaryAccount: false,
	accountType: 'CHECKING',
	accountTypeLabel: '',
	accountNumber: '',
	routingNumber: '',
	bankName: ''
};
